<ng-container *transloco="let t">
  <main #componentWrapper class="variant-product-card">
    <!-- Breadcrumbs -->
    @if (!(lessThan$ | async)?.sm) {
      <app-featured-breadcrumbs [product]="product"></app-featured-breadcrumbs>
    }
    <!-- Listing Details Card -->
    <app-featured-listing-details-card
      class="column premium-user"
      [product]="product"
      [currency]="product?.price?.currency"
      [galleryPictures]="pictures$ | async" />

    <span class="fixed-space-32" aria-hidden="true"></span>
    <!-- Google Bots test TEST -->
    @if (!isGoogleBotUserAgent) {
      <!-- Often Bought Together -->
      <span class="fixed-space-16" aria-hidden="true"></span>
      @defer {
        <app-bought-together-banner [product]="product"></app-bought-together-banner>
      } @loading {
        <span>loading</span>
      } @error {
        <span>loading</span>
      }

      @if (variant === 'ppVar1') {
        <app-best-sellers-picker />
        <app-category-picker [forceRow]="true" />
      }

      <!-- Coming Soon Banner -->
      @if (enableBuybackFeature() === true) {
        <app-coming-soon-banner />
      }

      @defer {
        <app-benefits-banner />
      } @loading {
        <span>loading</span>
      } @error {
        <span>loading</span>
      }

      <!-- Reviews -->
      <span class="fixed-space-16" aria-hidden="true"></span>
      <app-featured-reviews-card [product]="product"></app-featured-reviews-card>
      @if (!product) {
        <app-ui-skeleton class="column" [count]="3"></app-ui-skeleton>
      }
    }

    @if (!product) {
      <app-ui-skeleton class="column" [count]="3"></app-ui-skeleton>
    }
  </main>
</ng-container>
